<template>
  <div class="wd-my-3">
    <div class="wd-border-0 wd-border-b wd-border-solid wd-border-gray40">
      <div class="wd-flex wd-items-center wd-justify-between wd-py-3">
        <span class="wd-text-sm wd-text-black50">{{ $t('all_phone_number') }}</span>

        <button
          class="wd-text-base wd-text-orange50 disabled:wd-text-gray60 wd-pl-3 wd-py-1"
          :disabled="disabled"
          @click="showPhoneVerificationModal"
        >
          {{ isVerified ? $t('profile_edit_field') : $t('phone_verify_action') }}
        </button>
      </div>

      <p class="!wd-mb-0 wd-text-base wd-text-black50 wd-py-4">{{ isVerified ? phone : $t('profile_not_provided') }}</p>
    </div>

    <p class="!wd-mb-0 wd-py-2 wd-text-sm wd-text-gray80">{{ $t('ChangePhoneVC_clarification') }}</p>

    <ClientOnly>
      <PhoneVerificationModal ref="phoneVerificationModalRef" />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
const PhoneVerificationModal = defineAsyncComponent(() => import('@/components/member/PhoneVerificationModal.vue'))

interface Props {
  phone: string | null
  disabled?: boolean
}

const props = defineProps<Props>()

const phoneVerificationModalRef = useTemplateRef('phoneVerificationModalRef')

const isVerified = computed(() => !!props.phone)

function showPhoneVerificationModal() {
  phoneVerificationModalRef.value?.showModal()
}
</script>
